<template>
    <div class="chinese-preview">
        <div class="head">
            <i class="back"
               @click="back()"></i>
            <p class="title">预览</p>
        </div>
        <div class="main">
            <p class="title"
               v-if="chapter_name">《{{chapter_name}}》</p>
            <div class="list">
                <div class="item">
                    <p>课文朗读</p>
                    <span @click="toRead">查看</span>
                </div>
                <div class="item">
                    <p>视频导学</p>
                    <span @click="viewVideo">查看</span>
                </div>
                <div class="item">
                    <p>课文梳理</p>
                    <span @click="viewKwsl">查看</span>
                </div>
            </div>

        </div>
        <videoPlayer v-if="!inApp"
                     ref="videoPlayer"
                     @closePlayer="closePlayer"
                     v-show="videoPlay"
                     :video_url="video_url"></videoPlayer>
    </div>
</template>

<script>
import videoPlayer from 'SRC/components/base/videoPlayer.vue';  // 视频播放弹窗
export default {
    components: { videoPlayer },
    data () {
        return {
            inApp: localStorage.getItem("search") && Number(JSON.parse(localStorage.getItem("search")).platform),
            //sid
            sid: this.$route.params.sid,
            //unit_class_id
            paper_id: this.$route.params.paper_id,
            //课程名
            chapter_name: '',
            videoPlay: false,
            video_url: "",
            //课文朗读
            kwld: '',
            //课文梳理
            kwsl: 292,
            video: ''
        }
    },
    created () {
        this.getData()
    },
    methods: {
        getData () {
            let url = API_URL_HD_API + '/winter2023/stu/preview/'
            let params = {
                sid: this.sid,
                paper_id: this.paper_id
            }
            this.$http.post(url, params).then(res => {
                if (res.data.response == 'ok') {
                    this.chapter_name = res.data.data.chapter_name
                    this.video_url = res.data.data.video_url
                    this.kwld = res.data.data.kwld
                    this.video = res.data.data.video
                }
            })
        },
        //课文朗读
        toRead () {
            this.$router.push(`/activity/2024winter/kwld/${this.paper_id}`)
        },
        //视频导学
        viewVideo () {
            if (this.inApp) {
                this.appFunction("ys_video", `${this.video_url}`)
            } else {
                this.videoPlay = true;
                this.$nextTick(() => {
                    this.$refs.videoPlayer.play();
                })
            }
        },
        closePlayer () {
            this.videoPlay = false;
        },
        //查看课文梳理
        viewKwsl () {
            this.$router.push('/chinese/before/combing?id=' + this.paper_id + '&teaFlag=1&activity=2024winter')
        }
    }
}
</script>

<style lang="scss" scoped>
.chinese-preview {
    padding-top: 96px / $ppr;
    background: #fff;
    min-height: calc(100vh - 2.4rem);
}
.head {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100vw;
    height: 96px / $ppr;
    background: #5e89ef;

    .back {
        position: absolute;
        top: 0;
        left: 0;
        width: 76px / $ppr;
        height: 96px / $ppr;
        background: url(./img/choose_back.png) no-repeat center;
        background-size: 18px / $ppr 34px / $ppr;
    }

    .title {
        width: 100%;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        font-size: 34px / $ppr;
        color: #fff;
        text-align: center;
    }

    .preview {
        position: absolute;
        top: 0;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        right: 24px / $ppr;
        z-index: 10;
        font-size: 30px / $ppr;
        color: #fff;
    }
}
.main {
    padding: 0 24px / $ppr;
    .title {
        font-size: 36px / $ppr;
        padding: 50px / $ppr 0;
        text-align: center;
    }
    .list {
        .item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 15px / $ppr;
            border-radius: 10px / $ppr;
            border: 1px / $ppr solid #e8e8e8;
            margin-bottom: 24px / $ppr;
            p {
                font-size: 28px / $ppr;
            }
            span {
                display: inline-block;
                padding: 10px / $ppr 50px / $ppr;
                background: #5e89ef;
                color: #fff;
                border-radius: 57px / $ppr;
            }
        }
    }
}
</style>